<template>
    <span>
        <confirm-dialog ref="confirmDialog"></confirm-dialog>
        <v-btn v-bind="$attrs" @click="closeIncident()"><slot/></v-btn>
    </span>
</template>

<script>
import api from '@/api';
import ConfirmDialog from "@/components/common/ConfirmDialog";

export default {
    name: "CloseIncident",
    components : {ConfirmDialog},
    props: {
        incidentId:{type:Number},
        isCadIncident:{type:Boolean},
        onClose:{type:Function}
    },
    methods: {
        closeIncident() {
            const incidentId = this.incidentId;
            const isCadIncident = this.isCadIncident;

            if (!incidentId) {
                console.error("CloseIncident:: ID is Required!");
                return;
            }
            if (!isCadIncident) {
                this.$refs.confirmDialog.open('Close Incident', 'Close This Incident? You Will No Longer Be Able To Send Communications').then((confirm) => {
                    if (confirm) {
                        this.doCloseIncident();
                    }
                });
            } else {
                this.$root.$emit('showGlobalOverlay');
                api.incident.getStatus(this.incidentId).then((newIncident)=> {
                    if (newIncident.statusCode != 'CLOSED') {
                        this.$refs.confirmDialog.open('Not Closed', `This Incident Has Not Yet Been Closed in CAD. Current Status is ${newIncident.statusDesc}.  Do You Still Want to Close in the Portal?`).then((confirm) => {
                            if (confirm) {
                                this.doCloseIncident();
                            }
                        });
                    } else {
                        this.$refs.confirmDialog.open('Close Incident', 'Close This Incident? You Will No Longer Be Able To Send Communications').then((subConfirm) => {
                            if (subConfirm) {
                                this.doCloseIncident();
                            }
                        });
                    }
                }).finally(() => {
                    this.$root.$emit('hideGlobalOverlay');
                });
            }
        },
        doCloseIncident() {
            this.$root.$emit('showGlobalOverlay');
            let statusObj = {
                statusCode:"CLOSED",
                statusDesc:"Closed"
            }
            api.incident.updateStatus(this.incidentId,statusObj).then(()=> {
                this.$root.$emit('globalMessage','Incident Closed');
                this.$emit('onClose',this.incidentId);
            },(error)=>{
                console.log(error);
                this.$root.$emit('globalError','Error Closing Incident');
            }).finally(() => {
                this.$root.$emit('hideGlobalOverlay');
            })
        },
    }
}
</script>

<style scoped>

</style>